const accessoriesFilters = [
    {
        filterDisplayName: 'Food & Drink',
        filterType: 'collection',
        filterHandle: 'food-and-drink',
        subFilters: false,
    },
    {
        filterDisplayName: 'Romantic',
        filterType: 'collection',
        filterHandle: 'valentines-romantic-accessories',
        subFilters: false,
    },
    {
        filterDisplayName: 'Gaming & Tech',
        filterType: 'collection',
        filterHandle: 'gaming-accessories',
        subFilters: false,
    },
    {
        filterDisplayName: 'Sports & Hobbies',
        filterType: 'collection',
        filterHandle: 'hobby-and-sports',
        subFilters: false,
    },
    {
        filterDisplayName: 'Music',
        filterType: 'collection',
        filterHandle: 'music-accessories',
        subFilters: false,
    },
    {
        filterDisplayName: 'Animals',
        filterType: 'collection',
        filterHandle: 'animals',
        subFilters: false,
    },
    {
        filterDisplayName: 'Weapons',
        filterType: 'collection',
        filterHandle: 'weapons-and-armour',
        subFilters: false,
    },
    {
        filterDisplayName: 'Daily Use',
        filterType: 'collection',
        filterHandle: 'daily-use',
        subFilters: false,
    },
    {
        filterDisplayName: 'Home',
        filterType: 'collection',
        filterHandle: 'home',
        subFilters: false,
    },
    {
        filterDisplayName: 'Medical',
        filterType: 'collection',
        filterHandle: 'medical-accessories',
        subFilters: false,
    },
    {
        filterDisplayName: 'Work & Tools',
        filterType: 'collection',
        filterHandle: 'household-and-tools',
        subFilters: false,
    },
    {
        filterDisplayName: 'Retro',
        filterType: 'collection',
        filterHandle: 'retro-accessories',
        subFilters: false,
    },
    {
        filterDisplayName: 'Other',
        filterType: 'collection',
        filterHandle: 'random-accessories',
        subFilters: false,
    },
];

export { accessoriesFilters };
